module.exports = __webpack_public_path__ + "static/media/payment.c955a4d4.svg";